import { render, staticRenderFns } from "./PollDetails.vue?vue&type=template&id=451045e6&"
import script from "./PollDetails.vue?vue&type=script&lang=js&"
export * from "./PollDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports